'use strict';

var shopeeCommon = require('@mkt-common/shopee-common');

// This plug-in may run in non-DOM environments (e.g. React Native).
shopeeCommon.BASE_DOMAIN_SUFFIX.mx = "shopee.com.mx";
function generateCountry() {
  var _a, _b, _c;
  var country = 'sg';
  if (typeof COUNTRY !== 'undefined') {
    country = COUNTRY;
  } else if (typeof process !== 'undefined' && typeof process.env === 'object' && process.env.country) {
    country = process.env.country;
  }
  if (process.env.NODE_ENV !== 'production') {
    var urlMatchCountry = (((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.match) === null || _c === void 0 ? void 0 : _c.call(_b, /(sg|id|my|ph|tw|th|vn|br|mx)$/)) || [])[0];
    country = urlMatchCountry || country;
  }
  return country;
}
function getShopeeHostName() {
  var _a, _b, _c;
  var result = shopeeCommon.BASE_DOMAIN_SUFFIX[COUNTRY];
  if (result) {
    return result;
  }
  var regMatchGroup = ((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname) === null || _b === void 0 ? void 0 : _b.match) === null || _c === void 0 ? void 0 : _c.call(_b, /shopee.+$/)) || [];
  if (regMatchGroup[0]) {
    return regMatchGroup[0];
  }
}
var COUNTRY = generateCountry();
var passShopeeEnvironment = shopeeCommon.shopeeEnvironment;
function shouldUseLocationHost() {
  var _a;
  var url = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname;
  if ((url === null || url === void 0 ? void 0 : url.includes('seabank')) || (url === null || url === void 0 ? void 0 : url.includes('maribank'))) {
    return true;
  } else {
    return false;
  }
}
function getChatbotHost() {
  var _a;
  if (shouldUseLocationHost()) {
    return (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname;
  }
  var domainPrefix = getShopeeEnvironment() === 'live' ? '' : getShopeeEnvironment() === 'liveish' ? 'live-test.' : getShopeeEnvironment() + ".";
  var CHATBOT_SUBDOMAIN_PREFIX = 'chatbot.';
  return "" + CHATBOT_SUBDOMAIN_PREFIX + domainPrefix + getShopeeHostName();
}
function configShopeeEnvironment(shopeeEnvironment) {
  passShopeeEnvironment = shopeeEnvironment;
}
function getShopeeEnvironment() {
  return passShopeeEnvironment;
}
var COUNTRIES = {
  SG: 'sg',
  MY: 'my',
  TH: 'th',
  TW: 'tw',
  VN: 'vn',
  ID: 'id',
  PH: 'ph',
  BR: 'br',
  MX: 'mx',
  CO: 'co',
  CL: 'cl',
  AR: 'ar',
  PL: 'pl',
  ES: 'es',
  FR: 'fr',
  IN: 'in'
};
exports.COUNTRIES = COUNTRIES;
exports.COUNTRY = COUNTRY;
exports.configShopeeEnvironment = configShopeeEnvironment;
exports.getChatbotHost = getChatbotHost;